import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PurchaseChannelService } from '@core/services/entities/purchase-channel.service';
import { PurchaseChannelResponseDto } from '@domain/purchase-channel/dtos/purchase-channel.response.dto';
import { PurchaseChannelRepository } from '@domain/purchase-channel/repositories/purchase-channel.repository';
import { Observable } from 'rxjs';
import { GetPurchaseChannelRequestDto } from '@domain/purchase-channel/dtos/get-purchase-channel.request.dto';
import { CreatePurchaseChannelRequestDto } from '@domain/purchase-channel/dtos/create-purchase-channel.request.dto';
import { ListPurchaseChannelRequestDto } from '@domain/purchase-channel/dtos/list-purchase-channel.request.dto';
import { PageableResponse } from '@core/interface/pageable.interface';
import { UpdatePurchaseChannelRequestDto } from '@domain/purchase-channel/dtos/update-purhcase-channel.request.dto';
import { UpdateStatePurchaseChannelRequestDto } from '@domain/purchase-channel/dtos/update-state-purhcase-channel.request.dto';
import { RefId } from '@core/interface/ref-id.interface';
import { AssignFastPaymentChannelRequestDto } from '@domain/purchase-channel/dtos/assign-fast-payment-channel.request.dto';

@Injectable({
    providedIn: 'root',
})
export class PurchaseChannelRepositoryService
    implements PurchaseChannelRepository {
    constructor(private purchaseChannelService: PurchaseChannelService) { }
    create(
        request: CreatePurchaseChannelRequestDto,
    ): Observable<ApiResponse<PurchaseChannelResponseDto>> {
        return this.purchaseChannelService.create(request);
    }
    update(
        request: UpdatePurchaseChannelRequestDto,
    ): Observable<ApiResponse<PurchaseChannelResponseDto>> {
        return this.purchaseChannelService.update(request);
    }
    updateState(
        request: UpdateStatePurchaseChannelRequestDto,
    ): Observable<ApiResponse<PurchaseChannelResponseDto>> {
        return this.purchaseChannelService.updateState(request);
    }
    list(
        request: ListPurchaseChannelRequestDto,
    ): Observable<ApiResponse<PageableResponse<PurchaseChannelResponseDto>>> {
        return this.purchaseChannelService.list(request);
    }
    show(request: RefId): Observable<ApiResponse<PurchaseChannelResponseDto>> {
        return this.purchaseChannelService.show(request);
    }
    get(
        request: GetPurchaseChannelRequestDto,
    ): Observable<ApiResponse<PurchaseChannelResponseDto[]>> {
        return this.purchaseChannelService.get(request);
    }
    assignFastPayment(
        request: AssignFastPaymentChannelRequestDto,
    ): Observable<ApiResponse<void>> {
        return this.purchaseChannelService.assignFastPayment(request);
    }
}